
<div class="visor-container" [nbSpinner]="loading"
nbSpinnerStatus="danger"
nbSpinnerSize="large"
nbSpinnerMessage="Cargando datos..." >


  <div class="panel-body map-container" [attr.id]="config.target" ></div>

  <nb-card size="medimum" *ngIf="originalParcelas != undefined && originalParcelas.length > 0" class="parcelas-container">
    <nb-card-header>
      <div class="row">
        <div class="col-12"><h4>Mis Parcelas</h4></div>
     </div>
        <div class="row record-filter">
          <div class="col-6">
            <nb-select size="tiny" multiple placeholder="Municipio" shape="round" fullWidth="true"
            [(ngModel)]="selectedMunicipio" (selectedChange)="updateParcelasFilter($event)">

              <nb-option *ngFor="let municipio of municipios" value="{{municipio}}">{{municipio}}</nb-option>

            </nb-select>
          </div>

          <div class="col-6">
            <nb-select size="tiny" multiple placeholder="Cultivo" shape="round" fullWidth="true"
            [(ngModel)]="selectedCultivo" (selectedChange)="updateParcelasFilter($event)">

              <nb-option *ngFor="let cultivo of cultivos" value="{{cultivo.codCultivo}}">{{cultivo.cultivo}}</nb-option>

            </nb-select>
          </div>
        </div>
        <div class="row record-filter" style="margin-top: 8px;">

          <div class="col-12" *ngIf="visorFirebaseService.userData && visorFirebaseService.userData.groupUserAdministrator">
            <nb-select size="tiny" multiple placeholder="Propietario" shape="round" fullWidth="true"
            [(ngModel)]="selectedPropietario" (selectedChange)="updateParcelasFilter($event)">

              <nb-option *ngFor="let propietario of vGroupUsers" value="{{propietario.id}}">{{propietario.email}}</nb-option>

            </nb-select>
          </div>

        </div>

      </nb-card-header>

        <nb-list>
          <nb-list-item *ngFor="let parcela of parcelas">
            <div class="parcela-item" (click)="mostrarParcela(parcela.id)" >

              <div class="legend" [(style)]="'background-color:'+parcela.color"></div>

          <div class="parcela-title">

              <div class="parcela-alias">{{parcela.alias}} - {{parcela.campania?.cultivo ?? ''}} {{parcela.campania?.campania ?? ''}}</div>
              <div class="parcela-info">Prov. {{parcela.provincia}}, Mun. {{parcela.municipio}}, Agre. {{parcela.agregado}}, Zona {{parcela.zona}},<br/> Pol. {{parcela.poligono}}, Parc {{parcela.parcela}}</div>
              <div *ngIf="vUser==parcela.groupUserAdministrator">
                <div class="email-info" style="font-size: 12px; text-align: right;"> {{ getGroupUserEmail(parcela.userOwner) }}</div>
              </div>
          </div>
         </div>


          </nb-list-item>

        </nb-list>

  </nb-card>

  <div id="popup" *ngIf="parcelasigpac != null">
    <nb-card size="large">
      <!--
      <nb-card-header>
        <nav class="navbar navigation">
          <h3>Parcela</h3>
          <button nbButton status="primary" (click)="closeParcelaInfo()"><nb-icon icon="close-outline"></nb-icon>
          </button>
        </nav>
      </nb-card-header>
      -->
      <nb-card-body>
        <div class="info-parcela">

          <nb-tabset>

            <nb-tab *ngIf="parcelasigpac != null" tabTitle="Parcela">
              <div *ngIf="parcelasigpac.alias != null">
              <div class="row">
                <div *ngIf="parcelasigpac.color" class="col-sm-1 legend align-bottom">
                  <div class="legend-color" [(style)]="'background-color:'+parcelasigpac.color"></div>
                </div>
                <div class="col-sm-8">
                  <div class="form-group">
                    <label for="alias" class="label">Alias</label>
                    <input type="text" nbInput fullWidth id="alias" name="alias" [(ngModel)]="parcelasigpac.newAlias" >
                  </div>
                </div>

                <div class="col-sm-2 align-bottom">
                    <button nbButton status="primary"
                    nbTooltip="Visualizar el registro diario"
                    nbTooltipStatus="primary"  (click)="gotoDiario(parcelasigpac.id)" class="btn-diario"><nb-icon icon="list-outline"></nb-icon></button>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label for="alias" class="label">Cultivo</label>
                  <nb-select fullWidth placeholder="Cultivo" [(ngModel)]="parcelasigpac.campania.codCultivo">
                      <nb-option *ngFor="let producto of productos" value="{{producto.identifier}}">{{producto.name}}</nb-option>
                  </nb-select>
                  </div>
                  </div>
                <div class="col-6">
                  <div class="form-group">
                    <label for="alias" class="label">Campaña</label>
                  <nb-select fullWidth placeholder="Campaña" [(selected)]="parcelasigpac.campania.campaniaRef">
                    <nb-option *ngFor="let season of seasons" value="{{season.identifier}}">{{season.name}}</nb-option>
                    </nb-select>
                    </div>
                </div>

              </div>

            <div *ngIf="vUser==parcelasigpac.groupUserAdministrator">
              <div class="row">
                <div *ngIf="parcelasigpac.color" class="col-sm-1 legend align-bottom">
                  <div class="legend-color" [(style)]="'background-color:'+parcelasigpac.color"></div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="alias" class="label">Email propietario</label>
                    <input type="text" nbInput fullWidth id="email" name="email" [value]="getGroupUserEmail(parcelasigpac.userOwner)" >
                  </div>
                </div>
              </div>
            </div>

              <div class="row">
                <div class="col-sm-6 form-group">
                  <button nbButton status="primary"
                  fullWidth
                  nbTooltipStatus="primary"  (click)="closeParcelaInfo()">
                  Cerrar</button>
                </div>
                <div class="col-sm-6 form-group">
                  <button fullWidth (click)="guardarParcela(parcelasigpac)" nbButton status="success" [disabled]="parcelasigpac.userOwner && vUser != parcelasigpac.userOwner">Guardar<nb-icon icon="save-outline"></nb-icon></button>
                </div>
              </div>
            </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="provincia" class="label">Provincia</label>
                    <input type="text" nbInput fullWidth id="provincia" readonly="true" name="provincia" [(ngModel)]="parcelasigpac.parcelaInfo.provincia" >
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="municipio" class="label">Municipio</label>
                    <input type="text" nbInput fullWidth id="municipio" readonly="true" name="municipio" [(ngModel)]="parcelasigpac.parcelaInfo.municipio" >
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-3">
                  <div class="form-group">
                    <label for="agregado" class="label">Agregado</label>
                    <input type="text" nbInput fullWidth id="agregado" readonly="true" name="agregado" [(ngModel)]="parcelasigpac.parcelaInfo.agregado" >
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="form-group">
                    <label for="zona" class="label">Zona</label>
                    <input type="text" nbInput fullWidth id="zona" readonly="true" name="zona" [(ngModel)]="parcelasigpac.parcelaInfo.zona" >
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="form-group">
                    <label for="poligono" class="label">Polígono</label>
                    <input type="text" nbInput fullWidth id="poligono" readonly="true" name="poligono" [(ngModel)]="parcelasigpac.parcelaInfo.poligono" >
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="form-group">
                    <label for="parcela" class="label">Parcela</label>
                    <input type="text" nbInput fullWidth id="parcela" readonly="true" name="parcela" [(ngModel)]="parcelasigpac.parcelaInfo.parcela" >
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="superficie" class="label">Superficie (Ha)</label>
                    <input type="text" nbInput fullWidth id="superficie" readonly="true" name="superficie" [ngModel]="parcelasigpac.parcelaInfo.dn_surface / 10000 | number :'1.2-4'"
                    (ngModelChange)="item.value=$event" >
                  </div>
                </div>

                <div class="col-sm-8">
                  <div class="form-group">
                    <label for="refcatastral" class="label">Ref. Catastral</label>
                    <input type="text" nbInput fullWidth id="refcatastral" readonly="true" name="refcatastral" [(ngModel)]="parcelasigpac.parcelaInfo.referencia_cat" >
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-3">
                  <button nbButton status="primary"

                  nbTooltipStatus="primary"  (click)="closeParcelaInfo()" class="btn-diario">
                  Cerrar</button>

                </div>
              </div>
            </nb-tab>
            <nb-tab *ngIf="parcelasigpac != null" tabTitle="Recintos" [badgeText]="parcelasigpac.query.length"
            badgeStatus="success" class="recintos-tab">
              <div class="scrollable-container height-fix">
              <div *ngFor="let recinto of parcelasigpac.query">
                <div>
                <strong>Recinto {{recinto.recinto}}</strong>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="superficier" class="label">Superficie (Ha)</label>
                      <input type="text" nbInput fullWidth id="superficier" readonly="true" name="superficier"
                       [ngModel]="recinto.dn_surface / 10000 | number :'1.2-4'"
                      (ngModelChange)="item.value=$event" >
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="pendiente" class="label">Pendiente(%)</label>
                      <input type="text" nbInput fullWidth id="pendiente" readonly="true" name="pendiente"
                      [ngModel]="recinto.pendiente_media / 10 | number :'1.2-2'"
                      (ngModelChange)="item.value=$event">
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-8">
                    <div class="form-group">
                      <label for="uso" class="label">Uso</label>
                      <input type="text" nbInput fullWidth id="uso" readonly="true" name="uso"
                      [(ngModel)]="recinto.uso_sigpac" >
                    </div>
                  </div>

                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="region" class="label">Region</label>
                      <input type="text" nbInput fullWidth id="region" readonly="true" name="region"
                      [(ngModel)]="recinto.region" >
                    </div>
                  </div>
                </div>

                <span>Admisibilidad en Pastos</span>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="adporcentaje" class="label">Porcentaje</label>
                      <input type="text" nbInput fullWidth id="adporcentaje" readonly="true" name="adporcentaje"
                      [(ngModel)]="recinto.admisibilidad" >
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="superficie_admisible" class="label">Superficie</label>
                      <input type="text" nbInput fullWidth id="superficie_admisible" readonly="true" name="superficie_admisible"
                      [ngModel]="recinto.superficie_admisible / 10000 | number :'1.2-4'"
                      (ngModelChange)="item.value=$event" >
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="coregadio" class="label">Coef. Regadío</label>
                      <input type="text" nbInput fullWidth id="coregadio" readonly="true" name="coregadio"
                      [(ngModel)]="recinto.coef_regadio" >
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="incidencias" class="label">Incidencias</label>
                      <input type="text" nbInput fullWidth id="incidencias" readonly="true" name="incidencias"
                      [(ngModel)]="recinto.incidencias" >
                    </div>
                  </div>
                </div>

              </div>
              </div>
            </div>
            </nb-tab>

          </nb-tabset>


        </div>


        </nb-card-body>

    </nb-card>

</div>
  </div>
